import { render } from "./FrequentC.vue?vue&type=template&id=644bad4f"
const script = {}

import "./FrequentC.vue?vue&type=style&index=0&id=644bad4f&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__